import script from "./Account.vue?vue&type=script&lang=ts&setup=true"
export * from "./Account.vue?vue&type=script&lang=ts&setup=true"

import "./Account.vue?vue&type=style&index=0&id=9c8e5aa4&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-9c8e5aa4"]])

export default __exports__